import React from 'react'
import AllTransactionProvider from './index.provider'
import AllTransactionContent from './index.content'

const AllTransactionScreen: React.FC = () => {
  return (
    <AllTransactionProvider>
      <AllTransactionContent />
    </AllTransactionProvider>
  )
}

export default AllTransactionScreen
